export default {

  MUDAR_NAME(state, content) {
    state.name = content
  },
  SETBUILDERINFO(state, content) {
    state.builder = content
  },
  SETCURRENTINFO(state, content) {
    state.current = content
  },
  SET_REDE_SOCIAL(state, content) {
    state.redeSocial = content
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js